import { SVGIconProps } from 'fe-design-base/atoms/Icon/Icon';
const SvgComments = ({
  alt = 'Comments Icon',
  id,
  screenReadable = false,
}: SVGIconProps) => (
  <svg
    {...(screenReadable
      ? { role: 'img', 'aria-labelledby': id }
      : { 'aria-hidden': 'true' })}
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 31 24"
    fill="none"
  >
    {screenReadable && <title id={id}>{alt}</title>}

    <path
      d="M19.5469 8.25C19.5469 12.8438 15.1406 16.5 9.79688 16.5C7.96875 16.5 6.32812 16.125 4.875 15.375C3.70312 15.9844 2.20312 16.5 0.375 16.5C0.234375 16.5 0.09375 16.4531 0.046875 16.3125C0 16.1719 0 16.0312 0.140625 15.9375C0.140625 15.8906 1.21875 14.7656 1.96875 13.2188C0.75 11.8125 0.046875 10.125 0.046875 8.25C0.046875 3.70312 4.40625 0 9.79688 0C15.1406 0 19.5469 3.70312 19.5469 8.25ZM28.125 20.8125C28.875 22.3125 29.9062 23.3906 29.9062 23.4375C30 23.5312 30.0469 23.6719 30 23.8125C29.9531 23.9531 29.8125 24 29.6719 24C27.9844 24 26.5312 23.5312 25.3594 23.0156C24.0938 23.625 22.5938 24 21.0469 24C16.7812 24 13.2656 21.375 12.2812 17.7656C17.2969 16.7812 21.0469 12.8906 21.0469 8.25C21.0469 8.01562 21 7.78125 21 7.54688C21 7.54688 21 7.5 21.0469 7.5C26.0156 7.5 30.0469 11.2031 30.0469 15.75C30.0469 17.6719 29.2969 19.4062 28.125 20.8125Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgComments;
